<script lang="ts" setup>
import { ref, watch } from 'vue';

const visibleModel = ref<boolean>(false);
const resolvePromise = ref<(value: unknown) => void>();
const rejectPromise = ref<(value: unknown) => void>();

// Лимит сообщений в сутки на активном канале
const countMessagePerDay = ref('0');

const onClose = () => {
  visibleModel.value = false;
};

const show = (count: string) => {
  countMessagePerDay.value = count;
  visibleModel.value = true;
  return new Promise((resolve, reject) => {
    resolvePromise.value = resolve;
    rejectPromise.value = reject;
  });
};

const onConfirm = () => {
  resolvePromise.value!(true);
  visibleModel.value = false;
};

watch(visibleModel, (value) => {
  if (!value) resolvePromise.value!(false);
});

defineExpose({
  show,
});
</script>

<template>
  <PDialog v-model="visibleModel" width="small">
    <template #header>
      <header>
        <p>{{ $t('broadcast.modal.confirmWaited.title') }}</p>
        <IconCrossMd class="icon" @click="onClose" />
      </header>
    </template>
    <div class="main">
      <p>{{ $t('broadcast.modal.confirmWaited.description', { countMessagePerDay }) }}</p>
      <p>{{ $t('broadcast.modal.confirmWaited.hasQueue') }}</p>
    </div>
    <template #footer>
      <footer>
        <PButton class="button" color="secondary" @click="onClose">Отменить</PButton>
        <PButton class="button" @click="onConfirm">Отправить</PButton>
      </footer>
    </template>
  </PDialog>
</template>

<style scoped>
header {
  display: flex;
  position: relative;
  box-sizing: border-box;
  padding: 12px 16px;
  box-shadow: 0px -1px 0px 0px rgba(0, 0, 0, 0.08) inset;
}

header p {
  width: 100%;
  text-align: center;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
}

header .icon {
  position: absolute;
  right: 16px;
  cursor: pointer;
}

.main {
  box-sizing: border-box;
  padding: 24px 16px;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  color: var(--common-dark-water);
  display: flex;
  flex-direction: column;
  gap: 20px;
}

footer {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  padding: 8px 16px 16px 16px;
  gap: 12px;
}
</style>
